import Blocks from 'beisheim/components/blocks'

export default {
  BlocksComponent: Blocks
}
